<template>
  <el-dialog
    :visible.sync="show"
    width="600px"
    append-to-body
    :before-close="closeDialog"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="form-box">
      <div style="font-size: 22px;font-weight: 500;">可用余额：{{ total_money }}
        <el-button @click="toServiceFeeLists">前往充值</el-button>
        <p style="color: red;font-size: 14px;">可用余额是服务费账户余额，用余额购买短信费用{{submit_data.type==1?'0.045':'0.08'}}元/条</p>
      </div>
      <div style="display: flex; align-items: center;margin-top: 10px;">
        <div class="recharge-span">充值金额</div>

        <el-input
          v-model="submit_data.amount"
          @input="amountInput"
          style="width: 100px;"
        ></el-input>
        <span style="color: red;font-size: 12px;display: inline-block;margin-left: 10px;">余额充足可优先余额支付，享受优惠需在下方选择优惠项</span>
      </div>

      <el-button
        type="primary"
        class="submit-btn"
        @click="onSubmit('0')"
      >确 定</el-button>

      <div style="border-top: 1px solid #ccc;">
        <div
        class="recharge-span"
        style="margin-top: 20px;"
      >充值优惠</div>
      <div style="display: flex;justify-content: space-around;margin-top: 10px;">
        <div
          v-for="(item,index) in amountList"
          :key="index"
        >
        <p style="color: red;font-size: 14px;text-align: center;">{{ item.text }}元/条</p>
          <el-button
            :type="item.money == submit_data.amount? 'primary':''"
            size="medium"
            @click="numChange(item)"
          >{{item.money}}</el-button>
          <p style="color: red;font-size: 14px;text-align: center;">共{{ Math.floor(item.money/item.text) }}条</p>
        </div>
      </div>

      <div
        v-if="submit_data.pay_type == '1'"
        style="display: flex; align-items: center; flex-direction: column; margin-top: 20px"
      >
        <h1 style="font-size: 30px; color: #05c0ab">微信扫一扫支付</h1>
        <el-image
          :src="wxpayUrl"
          v-loading="loading"
        >
          <div slot="error">加载中<span class="dot">...</span></div>
        </el-image>
        <div>注：若二维码过期失效，请重新选择要充值的金额进行支付！</div>
      </div>
      </div>

      <!-- <div class="recharge-btn">
                <el-button
                    :type="btnChangeIndex == index ? 'primary' : 'info'"
                    @click="numChange(item, index)"
                    v-for="(item, index) in rechargeData"
                    :key="index"
                    >{{ item }}</el-button
                >
            </div>

            <div class="recharge-span" v-if="give_amount>0">
                一次性满<span style="color: #05c0ab">{{ submit_data.amount }}</span
                >元赠送<span style="color: #05c0ab">{{ give_amount }}</span
                >元短信条数
            </div>
            <div style="display: flex; align-items: center; flex-direction: column; margin-top: 20px">
                <h1 style="font-size: 30px; color: #05c0ab">微信扫一扫支付</h1>
                <el-image :src="wxpayUrl" v-loading="loading">
                    <div slot="error">加载中<span class="dot">...</span></div>
                </el-image>
                <div>注：若二维码过期失效，请重新选择要充值的金额进行支付！</div>
            </div> -->
    </div>

  </el-dialog>
</template>
<script>
var _this;
let myTimer;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置
export default {
    props: {
        isShow: Boolean,
        data: '',
        type: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;
            console.log(this.type, '===');
            this.submit_data.type = this.type;

            _this.$post('/service_fee/serviceFeeLists').then((res) => {
                this.total_money = res.data.total_money;
            });

            if (this.submit_data.type == 0) {
                _this.amountList = [
                    {
                        money: 3000,
                        text: '0.06'
                    },
                    {
                        money: 5000,
                        text: '0.05'
                    },
                    {
                        money: 10000,
                        text: '0.045'
                    }
                ];
            } else {
                _this.amountList = [
                    {
                        money: 3000,
                        text: '0.04'
                    },
                    {
                        money: 5000,
                        text: '0.035'
                    },
                    {
                        money: 10000,
                        text: '0.03'
                    }
                ];

                // console.log(_this.amountList,'_this.amountList');
            }

            // _this.default100(); //打开页面，充值默认为300；
        }
    },
    data() {
        return {
            timeModel: '',
            loading: true,

            total_money: '',
            wxpayUrl: '',
            trade_no: '',

            show: false,

            amountList: [
                {
                    money: 3000,
                    text: '0.06'
                },
                {
                    money: 5000,
                    text: '0.05'
                },
                {
                    money: 10000,
                    text: '0.045'
                }
            ],

            // 表单数据
            submit_data: {
                amount: '',
                type: '',
                pay_type: '0',

            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        toServiceFeeLists() {
            this.closeDialog();
            this.$router.push({ path: '/serviceFeeLists' });
        },

        //获取充值二维码
        onSubmit(pay_type) {
            if(pay_type){
                this.submit_data.pay_type = pay_type;
            }

            _this.$post('/service_fee/rechargeSMS', this.submit_data).then((res) => {
                this.closeDialog();
            });
        },

        amountInput() {
            this.submit_data.pay_type = '0';
        },

        numChange(item) {
            this.submit_data.amount = item.money;
            this.submit_data.pay_type = '1';
            this.loading = true;
            this.$post('/service_fee/rechargeSMS', this.submit_data).then((res) => {
                this.wxpayUrl = res.data.qr_img;
                this.loading = false;
                this.trade_no = res.data.req_seq_id;
                this.getPayStatus();
            });
        },

        getPayStatus() {
            // axios.defaults.baseURL = config.axios_normalURL;
            this.$post('/service_fee/payStatus', {
                req_seq_id: this.trade_no
            }).then((res) => {
                // axios.defaults.baseURL = config.axios_baseURL;
                if (res.data.status == 0) {
                    // 支付未完成
                    this.timeModel = setTimeout(() => {
                        this.getPayStatus();
                    }, 3000);
                } else {
                    this.$message({
                        type: 'success',
                        message: '支付成功'
                    });
                    // 支付完成
                    this.closeDialog();
                }
            });
            // axios.defaults.baseURL = config.axios_normalURL;
        },

        // 关闭方法
        closeDialog() {
            clearTimeout(this.timeModel);
            _this.show = false;
            // _this.rechargeData= ['300', '500', '800', '1000', '1500', '2000', '3000'],
            // _this.give_amount = '';
            _this.wxpayUrl = '';
            this.trade_no = '';

            this.$emit('onSubmit');
            for (const key in _this.submit_data) {
                _this.submit_data[key] = '';
            }
            // this.btnChangeIndex = '0';
        }
    }
};
</script>
<style scoped>
.recharge-btn {
    display: flex;
}
.form-box {
    padding: 20px 20px 0 20px;
    box-sizing: border-box;
    width: 100%;
}

.recharge-span {
    width: 100px;
    font-size: 18px;
    margin: 10px 0;

}
.submit-btn {
    display: block;
    margin: 20px auto;
    width: 100%;
}
</style>
<style>
.recharge-btn .el-button--info {
    border: 1px solid #05c0ab;
    background-color: #fff;
    color: #05c0ab;
}
.form-box .el-image__inner {
    width: 220px;
}

</style>

